<template>
  <div>
    <div
      id="_qn_admin_header"
      class="row no-wrap justify-between items-center"
    >
      <section class="admin-header-title">
        浙江省小微企业调查2021 ｜ 组长后台
      </section>
      <div class="admin-header-user-profile full-height row items-center">
        <UserPre size="30px"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    UserPre: () => import("../../../components/user/UserPre.vue"),
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";
#_qn_admin_header {
  height: 50px;
  position: relative;
  padding-left: 70px;
  padding-right: 20px;
  color: #fff;
  font-weight: bold;
  background-color: $tailong-blue;
  &::before {
    content: "";
    position: absolute;
    left: 0%;
    height: 100%;
    background-color: $primary;
    width: 70px;
    border-left: 20px solid $tailong-yellow;
  }

  &::after {
    content: "";
    position: absolute;
    right: 20px;
    height: 100%;
    background-color: $secondary;
    width: 100px;
    border-right: 20px solid $tailong-dark-blue;
  }
}
.admin-header-title {
  font-size: 1rem;
  padding-left: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.admin-header-user-profile {
  padding: 0 40px;
  z-index: 2;
}
.admin-header-user-profile-avatar {
  color: $primary;
  box-shadow: $shadow-4;

}
</style>
